import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Colors, Spacing, Typography } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import { ButtonTheme, ButtonV2 } from 'builder/components/Button'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.M};
  background-color: ${Colors.White};
  border-radius: 12px;
  padding: 32px 36px;
  flex: auto;

  ${Media.Phone`
    padding: 24px 16px;
  `}
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;

  ${Media.Phone`
    flex-direction: column;
    gap: 12px;
  `}
`

export const Header = styled.h2`
  ${Typography.sizes.Subhead};
  font-weight: ${Typography.weights.medium};
  color: ${Colors.Neutral90};
`

export const Info = styled.p`
  ${Typography.sizes.Body}
  color: ${Colors.Neutral50};
`

export const ProfileLink = styled(Link)`
  ${Typography.sizes.Body}
  font-weight: ${Typography.weights.medium};

  cursor: pointer;
  color: ${Colors.Blue50};
`

export const Description = styled.div`
  a {
    color: ${Colors.Blue50};
    font-weight: 500;
  }
  display: flex;
  color: ${Colors.Neutral50};
  margin-top: ${Spacing.S};
`

export const ContentWrapper = styled.div`
  position: relative;
`

export const NoResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.White};
  padding: 48px 0px;
  text-align: center;

  ${Media.Phone`
    padding: 32px 0;
  `}
`

export const CardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['2XS']};
`

export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;

  ${Media.Phone`
    width: 100%;
  `}
`

export const ActionButton = styled(ButtonV2).attrs({ theme: ButtonTheme.default })`
  display: block;
  width: auto;
  margin: auto;
  padding: 16px 24px;
  color: ${Colors.Neutral50};
  background-color: ${Colors.Neutral5};
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: ${Colors.Blue50};
    background-color: ${Colors.Blue10};
  }

  ${Media.Phone`
    width: 100%;
    margin-top: -12px;
  `}
`

export const MockJobCard = styled.div`
  border-radius: 12px;
  background: linear-gradient(180deg, ${Colors.Neutral5} 0%, rgba(247, 249, 252, 0) 323.53%);
  height: 136px;
`
